export { default } from './EnergiaSolar';
